import { useState, useMemo, useEffect, useRef } from 'react';
import buildItemsDepthMap from '../helpers/build-items-depth-map.js';

const useTreeViewData = (
  items,
  rootId,
  savedOpenFolderIds,
  defaultOpenFolderIdsOnSearch,
  searchQuery
) => {
  const [openNodeIds, setOpenNodeIds] = useState([]);
  const prevSearchQueryRef = useRef(null);

  useEffect(() => {
    if (!searchQuery) {
      prevSearchQueryRef.current = null;
      setOpenNodeIds(savedOpenFolderIds ?? []);
      return;
    }

    if (searchQuery !== prevSearchQueryRef.current) {
      prevSearchQueryRef.current = searchQuery;
      setOpenNodeIds(defaultOpenFolderIdsOnSearch ?? []);
    }
  }, [searchQuery, savedOpenFolderIds, defaultOpenFolderIdsOnSearch]);

  const { itemsDepthMap, descendantItemIds, childrenMap } = useMemo(
    () => buildItemsDepthMap(items, rootId),
    [items, rootId]
  );

  const visibleOrderIds = useMemo(() => {
    const order = [];

    const walk = (parentId) => {
      (childrenMap.get(parentId) || []).forEach((childId) => {
        order.push(childId);

        if (openNodeIds.includes(childId)) {
          walk(childId);
        }
      });
    };

    walk(rootId);

    return order;
  }, [childrenMap, openNodeIds, rootId]);

  return {
    openNodeIds,
    itemsDepthMap,
    descendantItemIds,
    visibleOrderIds,
    setOpenNodeIds,
  };
};

export default useTreeViewData;
